import DocumentUploadInput from './DocumentUploadInput';

export default DocumentUploadInput;
